import React from 'react';

import { format } from 'date-fns';
import { enUS, es, ja, pt } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

let { language } = window.navigator;

if (language.length > 2) {
    language = language.substr(0, 2);
}

const barHeight = 24;

const languageDateModules = {
    en: {
        locale: enUS,
        formatString: 'H:mm'
    },
    es: {
        locale: es,
        formatString: 'H:mm'
    },
    ja: {
        locale: ja,
        formatString: 'H:mm'
    },
    pt: {
        locale: pt,
        formatString: 'H:mm'
    }
};
const languageDateModule = languageDateModules[language] ?? languageDateModules.en;
const { formatString, locale } = languageDateModule;
interface RowProps {
    classActivity: any;
    classSessionData: any;
    index: number;
}

const eventColors = {
    BREAKOUT: 'RGB(165, 85, 70)',
    TAB: 'RGB(213,135,117)'
};

const ClassActivityTypeHeatmapUserRow: React.FC<RowProps> = ({ classActivity, classSessionData, index }) => {
    const { t } = useTranslation('portal');
    // const history = useHistory();
    console.log('classActivity', classActivity);
    const { event_name: eventName, reportingEvents } = classActivity;
    const { start_time: startTime, end_time: endTime } = classSessionData;

    console.log('index', index);

    if (reportingEvents.length === 0) {
        return <></>;
    }
    return (
        <>
            <div
                style={{
                    width: '100%',
                    position: 'relative',
                    height: `${barHeight}px`,
                    borderBottom: '1px solid #eee',
                    borderTop: index === 0 ? '1px solid #eee' : 'none',
                    backgroundColor: index % 2 === 0 ? '#fff' : '#fff'
                }}
            >
                <div
                    style={{
                        width: '200px',
                        height: `${barHeight}px`,
                        fontSize: '16px',
                        position: 'relative',
                        top: '-2px'
                    }}
                >
                    {t(`${eventName}-event-name`)}
                </div>
                <div
                    style={{
                        width: 'calc(100% - 200px)',
                        position: 'absolute',
                        top: '3px',
                        height: `${barHeight}px`,
                        left: '200px'
                    }}
                >
                    {reportingEvents.map((reportingEvent: any) => {
                        const color = eventColors[reportingEvent.event_type];
                        const startPercentage = Math.min(
                            1,
                            Math.max(
                                0,
                                (Number(reportingEvent.start_timestamp) / 1000 - startTime) / (endTime - startTime)
                            )
                        );
                        const endPercentage = Math.min(
                            1,
                            Math.max(
                                0,
                                (Number(reportingEvent.end_timestamp) / 1000 - startTime) / (endTime - startTime)
                            )
                        );
                        const totalPercentage = endPercentage - startPercentage;
                        console.log('reportingEvent', reportingEvent, 'totalPercentage', totalPercentage);
                        return (
                            <div
                                style={{
                                    backgroundColor: color,
                                    width: `${totalPercentage * 100}%`,
                                    left: `${startPercentage * 100}%`,
                                    height: `${barHeight - 5}px`,
                                    position: 'absolute',
                                    top: '-1px',
                                    zIndex: 2
                                }}
                                title={`${eventName} ${format(Number(reportingEvent.start_timestamp), formatString, {
                                    locale
                                })} - ${format(Number(reportingEvent.end_timestamp), formatString, { locale })}`}
                            ></div>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default ClassActivityTypeHeatmapUserRow;
